import { Component } from '@verndale/core';

class Modal extends Component {
  setupDefaults() {
    const { modalId } = this.el.dataset;

    this.dom = {
      body: document.querySelector('body'),
      modal: document.getElementById(modalId)
    };

    this.dom.close = this.dom.modal.querySelector('.modal__close');
  }

  addListeners() {
    this.el.addEventListener('click', this.handleClick.bind(this));
    this.dom.close.addEventListener('click', this.handleClose.bind(this));
  }

  handleClick() {
    this.dom.modal.showModal();
  }

  handleClose() {
    this.dom.modal.close();
  }
}

export default Modal;
